import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

// components
import Collapse from "@/components/Collapse";
import CommunityIcon from "@/components/icons/CommunityIcon";

// helpers
import { useDimension } from "@/hooks/useDimensions";

// assets
import styles from "@/assets/styles/containers/location-space-demographic-chart.module.scss";


export interface IAgePieChart {
  dataSource: Array<{ label: string; value: number, color: string }>;
  isMobileView?: boolean;
  isCollapsing?: boolean;
}

function AgePieChart({ dataSource, isMobileView, isCollapsing }: IAgePieChart) {
  const [width] = useDimension();

  const PIE_SIZE = isMobileView ? 140 : 160;
  const PIE_INNER_RADIUS = isMobileView ? 42 : 60;
  const PIE_OUTER_RADIUS = isMobileView ? 60 : 80;

  return (
    <Collapse
      className={`${styles["locl-location-space-demographic-chart"]}`}
      defaultActiveKey={["1"]}
      collapsible={isCollapsing ? "header" : "disabled"}
      key={`AgePieChart-${width}`}
    >
      <Collapse.Panel
        header={
          <div className={styles["locl-location-space-demographic-chart__header"]}>
            <div className={styles["locl-location-space-demographic-chart__header__content"]}>
              <div className={styles["locl-location-space-demographic-chart__header__icon"]}>
                <CommunityIcon />
              </div>
              <div className={styles["locl-location-space-demographic-chart__header__number"]}>
              Age
              </div>
            </div>
          </div>
        }
        showArrow
        key="1"
      >
        <div
          className={`${styles["locl-location-space-demographic-chart__body"]} ${styles["locl-location-space-demographic-chart__body_grid"]}`}
          data-testid="locl-location-space-demographic-pie-chart-body"
        >
          <div className={styles["locl-location-space-demographic-chart__inner"]}>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart width={PIE_SIZE} height={PIE_SIZE}>
                <Pie
                  data={dataSource}
                  innerRadius={PIE_INNER_RADIUS}
                  outerRadius={PIE_OUTER_RADIUS}
                  fill="#8884d8"
                  paddingAngle={2}
                  dataKey="value"
                >
                  {dataSource.map((_, index) => (
                    <Cell key={`AgePieChartCell-${index}`} fill={dataSource[index].color} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className={styles["locl-location-space-demographic-chart__chart-info"]}>
            {dataSource.map((item, index) => (
              <div
                key={`AgePieChartCellInfo-${index}`}
                className={styles["locl-location-space-demographic-chart__chart-info-item"]}
              >
                <span
                  className={styles["locl-location-space-demographic-chart__chart-info-item__color"]}
                  style={{ background: item.color }}
                />
                <span className={styles["locl-location-space-demographic-chart__chart-info-item__label"]}>
                  {`${item.label} - `}
                </span>
                <span className={styles["locl-location-space-demographic-chart__chart-info-item__value"]}>
                  {`${item.value}%`}
                </span>
              </div>
            ))}
          </div>
        </div>
      </Collapse.Panel>
    </Collapse>
  );
}

export default AgePieChart;
